const callbacksByRequestId = new Map()

export const onShareableSendSuccess = (requestId, callback) => {
  if (!requestId || typeof callback !== 'function') {
    return () => {}
  }

  const callbacks = callbacksByRequestId.get(requestId) ?? new Set()
  callbacks.add(callback)
  callbacksByRequestId.set(requestId, callbacks)

  return () => {
    callbacks.delete(callback)

    if (callbacks.size === 0) {
      callbacksByRequestId.delete(requestId)
    }
  }
}

export const notifyShareableSendSuccess = (requestId, payload) => {
  if (!requestId) return

  callbacksByRequestId.get(requestId)?.forEach((callback) => {
    try {
      callback(payload)
    } catch (error) {
      console.error('Error calling shareable send success callback:', error)
    }
  })
}
